
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

export default defineNuxtPlugin(async (nuxtApp) => {
  const { createPinia } = await import("pinia")
  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)

  nuxtApp.vueApp.use(pinia)
})
